import { withBusyIndicator } from "@components/busyIndicator/withBusyIndicator";
import SelectionTableViewBase from "@components/smart/selectionTableView/SelectionTableViewBase";


class PickSalaryComponentTableView extends SelectionTableViewBase {
    _keepActiveRowsOnFilterChange = false;

    get secondaryTitle(): string {
        return this.props.storage.t("SalaryComponent:SelectionTableView.Title");
    }

    get selectionConfirmText(): string {
        return this.props.storage.t("SalaryComponent:SelectionTableView.Complete");
    }

    get successMessage(): string {
        return this.props.storage.t("SalaryComponent:SelectionTableView.Success");
    }
}

export default withBusyIndicator({ passBusyIndicator: true })(PickSalaryComponentTableView);
